@use '~@frontrow/console/css/variables.scss';

.panelListContentNoDataText {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: variables.$font-size-md;
  padding: variables.$std-padding-md;
  height: 300px;
  font-style: italic;
}

.panelListContentContainer {
  overflow-y: scroll;
  max-height: 800px;
}
